import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DialogService, DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { MessageService, ConfirmationService, PrimeNGConfig } from 'primeng/api';
import { Title } from '@angular/platform-browser';
import { NavigationService } from '../../../../services/navigation/navigation.service';
import { CommonService } from '../../../../services/common/common.service';
import { VisitsDataService, VisitsColumnsService } from '../../../services';
import { Visit, VisitsResult } from '../../../interfaces';
import { Column } from '../../../interfaces/column.interface';

@Component({
  selector: 'app-visit-details',
  templateUrl: './visit-details.component.html',
  styleUrls: ['./visit-details.component.scss'],
  providers: [MessageService, ConfirmationService, DynamicDialogRef, DynamicDialogConfig],
})
export class VisitDetailsComponent implements OnInit, OnDestroy {

  public visit: Visit = {};
  public visits: Visit[] = [];
  public defaultParameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public parameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public isLoading: boolean = false;
  public locale: string = (localStorage.language)?localStorage.language:'en';
  public columns: Column[] = [];

  constructor(
    private translate: TranslateService,
    private common: CommonService,
    private router: Router,
    private route: ActivatedRoute,
    private dialogService: DialogService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private dynamicDialogConfig: DynamicDialogConfig,
    private primengConfig: PrimeNGConfig,
    private titleService: Title,
    private visitsDataService: VisitsDataService,
    private visitsColumnsService: VisitsColumnsService,

  ) { }

  ngOnInit(): void {
    this.route.params.subscribe((params: any) => {
      if (typeof params['id'] !== 'undefined') {
        this.titleService.setTitle('Visit - Details');
        this.getVisit(parseInt(params['id'], 10));
      }
    });
    if (this.dynamicDialogConfig.data && typeof this.dynamicDialogConfig.data.visit !== 'undefined') {
      this.visit = this.dynamicDialogConfig.data.visit;
    }
    this.columns = this.visitsColumnsService.getColumns();
  }

  ngOnDestroy(): void {
  }

  getVisit(id: number): void {
    this.isLoading = true;
    this.visitsDataService.getVisit(id).subscribe((response: Visit|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.visit = response;
      }
    });
  }

  list() {
    this.router.navigate(['/visits']);
  }

  add() {
    this.router.navigate(['/visits/add']);
  }

  edit() {
    this.router.navigate(['/visits/edit/' + this.visit.id]);
  }

}
@Component({
  selector: 'app-visit-details',
  templateUrl: './visit-details.component.html',
  styleUrls: ['./visit-details.component.scss'],
  providers: [MessageService, ConfirmationService],
})
export class DialogVisitDetailsComponent extends VisitDetailsComponent {
}

